var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlExchangeOutlined = function SvgHtlExchangeOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htlExchangeOutlined_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htlExchangeOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.021 15.073a7 7 0 0 1-4.08-2.184v.714a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-.86a6.016 6.016 0 0 0 3.599 1.983 6.02 6.02 0 0 0 4.51-1.08 6.1 6.1 0 0 0 2.3-6.442.5.5 0 1 1 .967-.254 7.053 7.053 0 0 1-.164 4.117 7.015 7.015 0 0 1-2.52 3.388 7 7 0 0 1-5.252 1.258Zm.479-3.165v-.84a3.945 3.945 0 0 1-1.65-.547.5.5 0 0 1 .53-.847c.342.205.724.336 1.12.384V8.285a2.245 2.245 0 0 1-1.664-1.29 1.654 1.654 0 0 1 .382-1.536c.354-.34.799-.572 1.281-.665v-.711a.5.5 0 0 1 1 0v.691c.113.015.228.037.345.064.461.109.903.29 1.31.534a.5.5 0 0 1-.538.843 3.6 3.6 0 0 0-1.023-.409l-.094-.019v1.72c.225.066.444.15.655.25a1.777 1.777 0 0 1 1.218 1.718 1.556 1.556 0 0 1-.92 1.29c-.3.149-.621.247-.953.29v.853a.5.5 0 1 1-.999-.001v.001Zm1-1.871c.174-.03.342-.085.5-.162a.586.586 0 0 0 .379-.462c.025-.4-.441-.681-.875-.85L8.5 10.037ZM6.929 6.162a.67.67 0 0 0-.14.529c.034.1.169.326.71.536v-1.4c-.211.07-.406.184-.57.335Zm-5.76 3.625a7.036 7.036 0 0 1 .165-4.117 7.01 7.01 0 0 1 2.52-3.389 7.014 7.014 0 0 1 5.254-1.258 7.01 7.01 0 0 1 4.081 2.186v-.715a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 1 1 0-1h.861a6.01 6.01 0 0 0-3.6-1.983 6.015 6.015 0 0 0-4.511 1.08 6.1 6.1 0 0 0-2.3 6.442.5.5 0 0 1-.97.254Z"
  }))));
};
export default SvgHtlExchangeOutlined;